import { Footer } from "./Footer";
import { Hero } from "./Hero";
import { Nav } from "./Nav";
import { graphite } from "./theme";

export type LandingPageProps = {
  rarionUrl: string;
  copyrightYear: number;
};

export function LandingPage(props: LandingPageProps) {
  const theme = graphite;
  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        background: theme.bg,
        color: theme.fg,
        fontFamily: theme.font,
      }}
    >
      <Nav theme={theme} rarionUrl={props.rarionUrl} />
      <Hero theme={theme} />
      <Footer theme={theme} copyrightYear={props.copyrightYear} />
    </div>
  );
}
